module.exports = __webpack_public_path__ + "img/btn-more-rooms.6473929d.svg";